module.exports = __webpack_public_path__ + "img/bg-white.262cb3c8.jpeg";